import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Icon from 'components/Kizen/Icon';
import { TextSpan } from 'app/typography';
import { gutters, layers } from 'app/spacing';
import Switch from '../Switch';

export const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border: 1px solid var(--color-border-medium);
  border-radius: 4px;

  :hover,
  :focus-within {
    cursor: pointer;
    border-color: var(--color-button-secondary-hover);
  }

  ${(props) =>
    props.hover &&
    css`
      cursor: pointer;
      border-color: var(--color-button-secondary-hover);
    `}

  ${(props) =>
    props.checked &&
    css`
      border: 1px solid var(--color-viz-cat-2-primary);
    `}

  ${(props) =>
    props.error &&
    css`
      border: 1px solid var(--color-button-warning-hover);
    `}
`;

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  z-index: ${layers.content(0)};
`;

export const StyledIcon = styled(Icon)`
  color: var(--color-font-placeholder);

  .fa-2x {
    font-size: 24px;
  }

  ${(props) =>
    props.checked &&
    css`
      color: var(--color-viz-cat-2-primary);

      &:hover {
        color: var(--color-viz-cat-2-primary);
      }
    `}
`;

export const StyledText = styled(TextSpan)`
  margin-top: ${gutters.standard};
  font-size: 14px;
  color: var(--color-font-placeholder);
  text-align: center;

  ${(props) =>
    props.checked &&
    css`
      color: var(--color-viz-cat-2-primary);
    `}
`;

export const StyledSwitch = styled(Switch)`
  margin: 8px 0 0 0;
`;
